enum ActionType {
    REQUEST_RELATIONSHIPS = 'RelationshipConnectionsActions.ON_BEFORE_GETRELATIONSHIPS',
    RECEIVE_RELATIONSHIP = 'RelationshipConnectionsActions.ON_GETRELATIONSHIPS',
    RESET_RELATIONSHIP = 'RelationshipConnectionsActions.ON_RESET_RELATIONSHIPS',
}

export default ActionType;
